import { Datastore, useDatastore, useSessionData } from "util/datastore";
import type { Comment } from "component/comment";
import { PushPermissionPopup } from "open-modules/zdf/platform-specific/pushNotifs";
import { logEventAsync } from "util/eventlog";
import { Feature } from "util/stdtypes";
import { QuestionConfig } from "structure/question";
import { setPushNotificationPermissionAsync } from "open-modules/zdf/component/notifications/push-notification";

export const PushNotificationPopupFeature: Feature<QuestionConfig, {}> = {
    name: "Show Push Notifications Popup",
    key: "pushnotificationspopup",
    dev: true,
    providesConfig: {
        commentPostTriggers: [shouldShowPushNotificationPermissionPopup],
        topBanners: [PermissionPopupWidget],
    }
}

type PushPermissionPopupArgs = { datastore: Datastore; comment: Comment; commentKey: string };

async function shouldShowPushNotificationPermissionPopup({ datastore, comment, commentKey }: PushPermissionPopupArgs) {
    datastore.setSessionData("requestNotificationPermission", true)
}

function PermissionPopupWidget () {
    const datastore = useDatastore();
    const hasUserWrittenAComment =  useSessionData(['requestNotificationPermission']);

    const onAllowNotifications = async () => {
        await setPushNotificationPermissionAsync({datastore, value: true});
        logEventAsync(datastore, 'push-notifs-allow', {source: "popup"});
    }

    const onNotAllowNotifications = () => {
        logEventAsync(datastore, 'push-notifs-not-allow', {source: "popup"});
    }

    if(!hasUserWrittenAComment) return null;
    return <PushPermissionPopup onAllow={onAllowNotifications} onNotAllow={onNotAllowNotifications}/>
}